












































import Vue from "vue";
import BasicCardTemplate from "./BasicCardTemplate.vue";
import { getModule } from "vuex-module-decorators";
import TodayModule from "@/views/Today/TodayModule";
import { bus } from "@/main";

interface State {
  module: TodayModule;
  email: string;
  playerName: string;
  loading: boolean;
}

export default Vue.extend({
  name: "NoPlayersListedCard",
  data(): State {
    return {
      module: getModule(TodayModule, this.$store),
      email: "",
      playerName: "",
      loading: false
    };
  },
  methods: {
    async requestAccess() {
      this.loading = true;
      const resp = await this.module.requestFanAccess({
        email: this.email,
        playerName: this.playerName
      });
      if (resp.data.success) {
        bus.$emit("successSnack", resp.data.message);
        this.email = "";
        this.playerName = "";
      } else {
        bus.$emit("errorSnack", resp.data.message);
      }
      this.loading = false;
    }
  }
});
